import { DEFAULT_LOCALE } from "@lib/constants";
import countries from 'i18n-iso-countries';
let registeredLocales = [];
export const getCountriesList = () => {
  var _localStorage$getItem;
  const locale = (_localStorage$getItem = localStorage.getItem('locale')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : DEFAULT_LOCALE;
  registerLocalIfNotRegistered(locale);
  const countryList = countries.getNames(locale, {
    select: "official"
  });
  return countryList;
};
export const getCountryNameByCode = code => {
  var _localStorage$getItem2;
  const locale = (_localStorage$getItem2 = localStorage.getItem('locale')) !== null && _localStorage$getItem2 !== void 0 ? _localStorage$getItem2 : DEFAULT_LOCALE;
  registerLocalIfNotRegistered(locale);
  return countries.getName(code, locale, {
    select: "official"
  });
};
export const translateIso2ToIso3 = iso2 => {
  return countries.alpha2ToAlpha3(iso2);
};
export const getIso2FromCountryName = countryName => {
  var _localStorage$getItem3;
  const locale = (_localStorage$getItem3 = localStorage.getItem('locale')) !== null && _localStorage$getItem3 !== void 0 ? _localStorage$getItem3 : DEFAULT_LOCALE;
  registerLocalIfNotRegistered(locale);
  return countries.getAlpha2Code(countryName, locale);
};
export const getIso3FromCountryName = countryName => {
  var _localStorage$getItem4;
  const locale = (_localStorage$getItem4 = localStorage.getItem('locale')) !== null && _localStorage$getItem4 !== void 0 ? _localStorage$getItem4 : DEFAULT_LOCALE;
  registerLocalIfNotRegistered(locale);
  return countries.getAlpha3Code(countryName, locale);
};
const registerLocalIfNotRegistered = locale => {
  if (!registeredLocales.includes(locale)) {
    countries.registerLocale(require("i18n-iso-countries/langs/".concat(locale, ".json")));
    registeredLocales.push(locale);
  }
};